import { useCallback } from 'react';
import { isRouteBetaFeatureEnabled, useBetaFeatures } from '@/entities/beta-feature';
import { PermissionCode, usePermissionsSet } from '@/entities/profile';
import { RouteConfig } from '@/shared/lib';

/**
 * Предикат видимости пункта навигации для текущего пользователя: разрешение на просмотр
 * и включённость бета-функции, за которой пункт закрыт.
 *
 * Нужен там, где пункты берутся списком, а не рисуются каждый своим компонентом: правило
 * видимости должно быть одно на все места показа пункта, иначе меню-подсказка свёрнутой
 * группы предлагает то, чего в самом меню нет, и ведёт на закрытый адрес. Само правило
 * бета-функции здесь не переписывается — берётся у сущности (`isRouteBetaFeatureEnabled`),
 * той же, что стоит за хуками одиночного пункта.
 */
export const useIsRouteVisible = () => {
  const permissions = usePermissionsSet();
  const { data } = useBetaFeatures();

  return useCallback(
    (route: RouteConfig) => {
      const codes = [route.viewPermission].flat().filter((code): code is PermissionCode => !!code);
      const allowView = codes.length === 0 || codes.some((code) => permissions.has(code));

      return allowView && isRouteBetaFeatureEnabled(data?.features, route.betaFeature);
    },
    [permissions, data],
  );
};
